import { Component, inject, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { DatePickerFilter, FilterComponent, FilterItem, SelectFilter } from '@h5s/design-system';
import { today } from '@h5s/util-date';
import { FeaturePsService } from '../../../feature-ps.service';
import { FEATURE_PS_TRANSLATIONS } from '../../translations/feature-ps.translations';
import { PsFilterModel } from './models/ps-filters-model';

@Component({
  selector: 'h5s-ps-filter',
  imports: [ReactiveFormsModule, FilterComponent],
  templateUrl: './ps-filter.component.html',
  styleUrl: './ps-filter.component.scss',
})
export class PsFilterComponent {
  private readonly featurePsService = inject(FeaturePsService);

  /** Traduzioni */
  public readonly translation = FEATURE_PS_TRANSLATIONS;

  public readonly profileOptions = toSignal(this.featurePsService.getOwnerPublicSecurityRecord());

  /** Outputs */
  public filterChange = output<PsFilterModel>();

  /** Configurazione dei campi del filtro */
  public readonly filterItems: FilterItem<PsFilterModel>[] = [
    new SelectFilter({
      key: 'profile',
      label: this.translation.profileFilter,
      dataList: toSignal(this.featurePsService.getOwnerPublicSecurityRecord(), { initialValue: [] }),
      getChipDisplayValue: (filterModel) => {
        const profile = filterModel['profile'];
        const options = this.profileOptions();
        return options && profile ? options[profile] : '';
      },
      isMainFilter: true,
      validators: [Validators.required],
    }),
    new DatePickerFilter({
      key: 'date',
      label: this.translation.dateFilter,
      defaultValue: today(),
      isMainFilter: true,
      validators: [Validators.required],
    }),
  ];
}
